<template>
  <div v-if="columns">
    <table class="table tablesorter" :class="tableClass" style="width: 99.8%">
      <thead :class="theadClasses">
      <tr>
        <slot name="columns">
          <th v-for="(column, index) in columns" :key="index" v-if="column.show">
            {{ column.header }}
            <i v-if="column.sort && column.name!==sortBy" v-on:click="changeSortBy(column)" class="tim-icons icon-minimal-right"></i>
            <i v-else-if="column.sort && column.name===sortBy && !column.direction" class="tim-icons icon-minimal-down"></i>
            <i v-else-if="column.sort && column.name===sortBy && column.direction && sortDirection" v-on:click="changeDirection(column)" class="tim-icons icon-minimal-down"></i>
            <i v-else-if="column.sort && column.name===sortBy && column.direction && !sortDirection" v-on:click="changeDirection(column)" class="tim-icons icon-minimal-up"></i>
          </th>
        </slot>
      </tr>
      </thead>
      <tbody v-if="data && data.length && data.length > 0" :key="tableKey">
      <tr v-for="(item, index) in data" :key="index" :style="!item.view || item.view === 'row' ? 'background: #f6f6f6' : ''">
        <slot v-if="item.id && !item.view || item.view === 'row'" :row="item">
          <td v-for="(column, indexTd) in columns" style=""
              :key="indexTd"
              v-if="column.show"
          >
            <div v-if="column.action">
              <div v-if="column.toDelete">
                <i class="tim-icons icon-simple-remove" v-on:click="deleteItem(index)" style="margin-right: 10px"></i>
              </div>
            </div>
            <div v-else-if="column.noAction">
              <span v-if="!column.rows">
                {{itemValue(item.object, column.name, column.periodView, column.cut)}}
              </span>
              <p v-else v-for="(row, index) in itemValue(item.object, column.name, column.periodView, column.cut).split('$$')" :key="index">
                {{row}}
              </p>
            </div>
            <div v-else v-on:click="updateView(index, 'view')">
              <span v-if="!column.rows">
                {{itemValue(item.object, column.name, column.periodView, column.cut)}}
              </span>
              <p v-else v-for="(row, index) in itemValue(item.object, column.name, column.periodView, column.cut).split('$$')" :key="index">
                {{row}}
              </p>
            </div>
          </td>
        </slot>
        <slot v-else-if="item.view && item.view === 'view' && item.object.id" :row="item">
          <td :colspan="getNumberOfColumns()" style="border-color: grey; border-style: solid; border-width: 4px">
            <div style="width: 99%">
              <client-view v-if="type === 'client'" :item="item"
                           @toRow="updateView(index, 'row')" @toEdit="updateView(index, 'edit')"
              ></client-view>

              <call-view v-else-if="type === 'call'" :item="item"
                         @toRow="updateView(index, 'row')"
                         @toEdit="updateView(index, 'edit')"
              ></call-view>

              <base-tsr-view v-else-if="type === 'base_tsr'" :item="item"
                             @toRow="updateView(index, 'row')" @toEdit="updateView(index, 'edit')"
              ></base-tsr-view>

              <compensation-view v-else-if="type === 'compensation'" :item="item"
                                 @toRow="updateView(index, 'row')" @toEdit="updateView(index, 'edit')"
              ></compensation-view>

              <ipr-view v-else-if="type === 'ipr'" :item="item"
                        @toRow="updateView(index, 'row')" @toEdit="updateView(index, 'edit')"
              ></ipr-view>

              <doc_pattern-view v-else-if="type === 'doc_pattern'" :item="item"
                        @toRow="updateView(index, 'row')" @toEdit="updateView(index, 'edit')"
              ></doc_pattern-view>

              <doc-view v-else-if="type === 'document'" :item="item"
                                @toRow="updateView(index, 'row')" @toEdit="updateView(index, 'edit')"
              ></doc-view>

              <tsr-view v-else-if="type === 'tsr'" :item="item"
                        @toRow="updateView(index, 'row')" @toEdit="updateView(index, 'edit')"
              ></tsr-view>

              <kit-view v-else-if="type === 'kit'" :item="item"
                        @toRow="updateView(index, 'row')" @toEdit="updateView(index, 'edit')"
              ></kit-view>

              <product-view v-else-if="type === 'product'" :item="item"
                            @toRow="updateView(index, 'row')" @toEdit="updateView(index, 'edit')"
              ></product-view>

              <item-view v-else-if="type === 'item'" :item="item"
                         @toRow="updateView(index, 'row')" @toEdit="updateView(index, 'edit')"
              ></item-view>

              <simple-name-view v-else-if="type === 'productCategory' || type === 'disabledCategory' ||  type === 'socialType'
              ||type === 'group'  || type === 'workType'"
                                :item="item"
                                @toRow="updateView(index, 'row')" @toEdit="updateView(index, 'edit')"
              ></simple-name-view>

              <file-view v-else-if="type === 'file'" :item="item"
                         @toRow="updateView(index, 'row')" @toEdit="updateView(index, 'edit')"
              ></file-view>

              <contract-view v-else-if="type === 'contract'" :item="item"
                         @toRow="updateView(index, 'row')" @toEdit="updateView(index, 'edit')"
              ></contract-view>
            </div>

          </td>
        </slot>
        <slot v-else-if="item.view && item.view === 'edit'" :row="item">
          <td :colspan="getNumberOfColumns()" style="border-color: #017cf8; border-style: solid; border-width: 4px">
            <div style="width: 99%">
              <client-edit v-if="type === 'client'" :item="item" :type="type" @delete="deleteItem(index)"
                           @toRow="updateView(index, 'row')" @toView="updateView(index, 'view')"
              ></client-edit>

              <call-edit v-else-if="type === 'call'" :item="item" :type="type" @delete="deleteItem(index)"
                         @toRow="updateView(index, 'row')" @toView="updateView(index, 'view')"
              ></call-edit>

              <base-tsr-edit v-else-if="type === 'base_tsr'" :item="item" :type="type" @delete="deleteItem(index)"
                             @toRow="updateView(index, 'row')" @toView="updateView(index, 'view')"
              ></base-tsr-edit>

              <compensation-edit v-else-if="type === 'compensation'" :item="item" :type="type" @delete="deleteItem(index)"
                                 @toRow="updateView(index, 'row')" @toView="updateView(index, 'view')"
              ></compensation-edit>

              <ipr-edit v-else-if="type === 'ipr'" :item="item" :type="type" @delete="deleteItem(index)"
                        @toRow="updateView(index, 'row')" @toView="updateView(index, 'view')"
              ></ipr-edit>

              <tsr-edit v-else-if="type === 'tsr'" :item="item" :type="type" @delete="deleteItem(index)"
                        @toRow="updateView(index, 'row')" @toView="updateView(index, 'view')"
              ></tsr-edit>

              <doc_pattern-edit v-else-if="type === 'doc_pattern'" :item="item" :type="type" @delete="deleteItem(index)"
                                @toRow="updateView(index, 'row')" @toView="updateView(index, 'view')"
              ></doc_pattern-edit>

              <doc-edit v-else-if="type === 'document'" :item="item" :type="type" @delete="deleteItem(index)"
                        @toRow="updateView(index, 'row')" @toView="updateView(index, 'view')"
              ></doc-edit>

              <kit-edit v-else-if="type === 'kit'" :item="item" :type="type" @update_top="updateTop" @delete="deleteItem(index)"
                        @toRow="updateView(index, 'row')" @toView="updateView(index, 'view')"
              ></kit-edit>

              <product-edit v-else-if="type === 'product'" :item="item" :type="type" @delete="deleteItem(index)"
                            @toRow="updateView(index, 'row')" @toView="updateView(index, 'view')"
              ></product-edit>

              <item-edit v-else-if="type === 'item'" :item="item" :type="type" :index="index" @delete="deleteItem(index)"
                         @toRow="updateView(index, 'row')" @toView="updateView(index, 'view')"
              ></item-edit>

              <simple-name-edit v-else-if="type === 'productCategory' || type === 'disabledCategory' ||  type === 'socialType'
            || type === 'group' || type === 'workType'"
                                :item="item" :type="type" @delete="deleteItem(index)"
                                @toRow="updateView(index, 'row')" @toView="updateView(index, 'view')"
              ></simple-name-edit>

              <file-edit v-else-if="type === 'file'" :item="item" :type="type" @update_top="updateTop" @delete="deleteItem(index)"
                         @toRow="updateView(index, 'row')" @toView="updateView(index, 'view')"
              ></file-edit>
              <contract-edit v-else-if="type === 'contract'" :item="item" :type="type" @update_top="updateTop" @delete="deleteItem(index)"
                         @toRow="updateView(index, 'row')" @toView="updateView(index, 'view')"
              ></contract-edit>

            </div>
          </td>
        </slot>
      </tr>

      </tbody>
    </table>
  </div>

</template>
<script>

import {getValueByField, longAsStringDate} from "@/services/utils";
import {ClientEdit} from "@/components/index";
import SimpleNameEdit from "@/model/SimpleNameEdit";
import {convertLongToPeriod} from "@/services/periods-service";
import ContractView from "@/model/ContractView";

export default {
  name: 'base-table',
  components:{
    ContractView,
    SimpleNameEdit,
    ClientEdit
  },
   props:{
     tableClass: {
       type: String,
       default: ''
     },
     theadClasses:{
       type: String,
       default: ''
     },
     tbodyClasses:{
       type: String,
       default: ''
     },
     data:{
       type: Array,
       default: () => []
     },
     columns:{
       type: Array,
       default: ()=>[]
     },
     sortBy:{
       type: String,
       default: ''
     },
     sortDirection:{
       type: Boolean,
       default: true
     },
     type:{
       type: String,
       default: 'none'
     }
   },
   data() {
     return {
       tableKey: 0
     }
   },
   methods: {
     itemValue(item, column, periodView, cut) {
       let value = this.getValue(item, column);
       if (value) {
         if (periodView) {
           return convertLongToPeriod(value).name;
         } else if (column.date || column.toLowerCase().includes("date") || column.toLowerCase().includes("time")) {
           return longAsStringDate(value);
         } else if (cut) {
           let text = String(value);
           let length = cut[1] - cut[0];
           let textLength = text.length;
           if (textLength < length + 6) {
             return text;
           } else {
             return text.substring(cut[0], textLength > cut[1] ? cut[1] : textLength - 1) + '...';
           }
         }
         else {
           return value;
         }
       } else {
         return "-"
       }
     },
     getValue(item, column) {
       return item ? getValueByField(item, column) : '-';
     },
     changeDirection(column) {
       this.$emit('sort', {name: column.name, direction: column.direction ? !this.sortDirection : true});
     },
     changeSortBy(column) {
       this.$emit('sort', {name: column.name, direction: true});
     },
     getNumberOfColumns() {
       let rsl = 0;
       this.columns.forEach(column => {
         if (column.show) {
           rsl++;
         }
       })
       return rsl;
     },
     updateView(index, view) {
       let item = this.data[index];
       this.updateTop();
       item.view = view;
       this.data.splice(index, 1, item);
     },
     updateTop() {
       this.$emit('update_top')
     },
     deleteItem(index) {
       this.data[index].view = null;
       this.tableKey++;
     }
   }
 }
</script>
<style>
</style>
